import { apiClient } from './_shared.js'

// ============================================
// TELEGRAM BOT
// ============================================

export async function generateTelegramLinkCode(userId) {
  const data = await apiClient(`/employees/${userId}/telegram-code`, { method: 'POST' })
  return data?.code
}

export async function unlinkTelegram(userId) {
  await apiClient(`/employees/${userId}/telegram`, { method: 'DELETE' })
}

export async function sendTelegramNotification(type, data) {
  try {
    const data = await apiClient('/telegram-notify', {
      method: 'POST',
      body: JSON.stringify({ type, data }),
    })
    return !!data
  } catch {
    return false
  }
}
